// Плашка про cookie рендерится сервером (layouts/_cookie_notice), пока нет cookie cookie_notice.
const ONE_YEAR = 60 * 60 * 24 * 365

document.addEventListener("click", (event) => {
  if (!event.target.closest("[data-cookie-notice-accept]")) return

  document.cookie = `cookie_notice=1; path=/; max-age=${ONE_YEAR}; SameSite=Lax`
  document.querySelector("[data-cookie-notice]")?.remove()
})
